import { JsonType } from 'posthog-js';

import { InitialState } from '../types/hubTypes';

/**
 * Get all feature flags from the store
 *
 * @param {Object} state - Redux state
 * @returns {Object} Object containing all feature flags
 */
export const getFeatureFlags = (state: InitialState): Record<string, boolean> => state.featureFlags?.flags || {};

/**
 * Get a specific feature flag by name
 *
 * @param {Object} state - Redux state
 * @param {string} flagName - The name of the feature flag
 * @returns {boolean} Whether the feature flag is enabled
 */
export const getFeatureFlag = (state: InitialState, flagName: string): boolean => {
  const flags = getFeatureFlags(state);
  return flags[flagName] || false;
};

/**
 * Get all feature flag payloads from the store
 *
 * @param {Object} state - Redux state
 * @returns {Object} Object containing all feature flag payloads
 */
export const getFeatureFlagPayloads = (state: InitialState): Record<string, JsonType> =>
  state.featureFlags?.payloads || {};

/**
 * Get a specific feature flag payload by name
 *
 * @param {Object} state - Redux state
 * @param {string} flagName - The name of the feature flag
 * @returns {*} The payload for the feature flag, or undefined if not found
 */
export const getFeatureFlagPayload = (state: InitialState, flagName: string): JsonType => {
  const payloads = getFeatureFlagPayloads(state);
  return payloads[flagName];
};

/**
 * Check if feature flags have been loaded
 *
 * @param {Object} state - Redux state
 * @returns {boolean} Whether feature flags have been loaded
 */
export const getFeatureFlagsLoaded = (state: InitialState): boolean => state.featureFlags?.isLoaded || false;
